import { render, staticRenderFns } from "./qualityApprovalAdd.vue?vue&type=template&id=30460cfc&scoped=true"
import script from "./qualityApprovalAdd.vue?vue&type=script&lang=js"
export * from "./qualityApprovalAdd.vue?vue&type=script&lang=js"
import style0 from "./qualityApprovalAdd.vue?vue&type=style&index=0&id=30460cfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30460cfc",
  null
  
)

export default component.exports